var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumReg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B0F73",
    d: "M12 1l9 4v6c0 5.55-3.84 10.74-9 12-5.066-1.237-8.86-6.263-8.996-11.698L3 11V5l9-4zm0 2.19L5 6.3V11c0 4.52 2.98 8.69 7 9.93 3.934-1.214 6.873-5.234 6.996-9.642L19 11V6.3l-7-3.11zm-.43 4.607c.159-.396.701-.396.86 0l.884 2.182 2.257.2c.412.034.58.572.267.856l-1.716 1.556.514 2.308c.094.42-.34.753-.696.528L12 14.2l-1.94 1.223c-.355.225-.79-.108-.696-.529l.514-2.308-1.716-1.556c-.313-.283-.145-.821.267-.856l2.257-.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumReg);
export default __webpack_public_path__ + "static/media/premium_reg.b512a140e2dd20592c393ee63dbbc610.svg";
export { ForwardRef as ReactComponent };